/*
 * @Desc: 班级管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-01 18:26:54
 */
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/link/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/link/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/link/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/link/detail",
      method: "post",
      params: query
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/link/remove",
      method: "post",
      data
    });
  },
  // 排序
  sort(data) {
    return request({
      url: "/link/sort",
      method: "post",
      data
    });
  },
};
export default index;